import { render, staticRenderFns } from "./ProductCenter.vue?vue&type=template&id=67d69e32&scoped=true"
import script from "./ProductCenter.vue?vue&type=script&lang=js"
export * from "./ProductCenter.vue?vue&type=script&lang=js"
import style0 from "./ProductCenter.vue?vue&type=style&index=0&id=67d69e32&prod&scoped=true&lang=less"
import style1 from "./ProductCenter.vue?vue&type=style&index=1&id=67d69e32&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d69e32",
  null
  
)

export default component.exports